import { useCallback, useEffect, useRef } from "react"
import { debounce } from "lodash"
import styles from "./ChartDimensions.module.scss"

const ChartDimensions = (props) => {
  const { setDimensions } = props
  const chartRef = useRef(null)

  const updateDimensions = useCallback((refElement) => {
    const chartWrapper = refElement
    const height = chartWrapper?.offsetHeight
    const width = chartWrapper?.offsetWidth
    setDimensions({ width, height })
  }, [])

  const debouncedUpdateDimensions = useCallback(
    debounce((refElement) => updateDimensions(refElement), 300),
    [updateDimensions]
  )

  useEffect(() => {
    // Initial call to set dimensions
    debouncedUpdateDimensions(chartRef.current)

    // Watch for changes in the wrapper div and update dimensions accordingly
    const resizeObserver = new ResizeObserver(() =>
      debouncedUpdateDimensions(chartRef.current)
    )
    resizeObserver.observe(chartRef.current)

    // Cleanup function to disconnect the observer when the component unmounts
    return () => {
      resizeObserver.disconnect()
    }
  }, [])

  return (
    <div className={styles.chartDimensions} ref={chartRef}>
      {props.children}
    </div>
  )
}

export default ChartDimensions
